import styled from "styled-components";
import Container from "react-bootstrap/Container";
import {TEXT_COLOR} from "../../Constants";

const StyledFooterContainer = styled(Container)`
  border-top: 2px solid ${TEXT_COLOR};
`

export {StyledFooterContainer}